(function(window, $, undefined) {
    window.JVZoo = window.JVZoo || {};
    window.JVZoo.Auth = window.JVZoo.Auth || {};
    window.JVZoo.Auth.TotpAuthenticator = window.JVZoo.Auth.TotpAuthenticator || {};

    var _showSpeed = 1000;
    var _hideSpeed = _showSpeed/2;

    var getAuthForm = function () {
        return document.getElementById("login_form") || document.getElementById("reset_password_form");
    };

    /**
     * Ensures login submit controls are clickable after 2FA modal interactions.
     */
    var enableLoginSubmitButtons = function () {
        var selectors = '.g-recaptcha[type=submit], #authenticatedSubmit';
        $(selectors).prop('disabled', false).removeClass('disabled');
    };

    /**
     * Retrieves an Account Id value from the specified field or the default field name.
     * @returns {null|string}
     * php
     */
    var getLoginEmailValue = function () {
        var selector = '[name=login]';
        var $element = $(selector);
        if ($element.length < 1) {
            console.error("Failed to find element matching selector \"" + selector + "\"");
            return null;
        }
        if ($element.length > 1) {
            console.error("Found more than one element matching selector \"" + selector + "\"");
            return null;
        }
        if (!$element.val()) {
            if (window.JVZoo.Debug) {
                console.warn("The element matching selector \"" + selector + "\" does not have a value.");
            }
            return null;
        }
        return $element.val();
    }

    /**
     *
     * @param loginEmail
     * @returns {Promise<any>}
     * @phpDependency(references={"\Auth::requiresTotpAuthenticator"})
     */
    var shouldRenderTotpAuthComponent = function (loginEmail) {
        if (window.JVZoo.Debug) {
            console.log('Checking 2FA requirement for email: ', loginEmail);
        }
        var postData = new FormData();
        postData.append(window.JVZoo.Security.GetCsrfFieldName(), window.JVZoo.Security.GetCsrfHash());
        postData.append('login', loginEmail);
        return fetch(
            '/auth/requiresTotpAuthenticator',
            {
                method: 'POST',
                headers: {'Accept': 'application/json'},
                mode: 'same-origin',
                cache: 'no-cache',
                credentials: 'same-origin',
                redirect: 'error',
                referrerPolicy: "same-origin",
                body: postData,
            }
        )
            .then(function (response) {
                if (response.status == 204) {
                    var form = getAuthForm();
                    if (!form) {
                        console.error('No auth form found.');
                        return;
                    }
                    form.submit();
                }
                if (response.status == 200) {
                    window.JVZoo.Auth.TotpAuthenticator.Show($("#two-factor-auth"));
                }
                if (window.JVZoo.Debug) {
                    console.debug(response);
                }
                return response.json();
            });
    };

    /**
     * Fades an HTML element into view
     * @param element
     * @returns {boolean}
     * @constructor
     */
    window.JVZoo.Auth.TotpAuthenticator.Show = function (element) {
        var $element = element instanceof $ ? element : $(element);
        if ($element.length < 1) {
            return false;
        }
        $element.each(function (index, target) {
            $(target).fadeIn(_showSpeed);
        });
        return true;
    };
    /**
     * Fades an HTML element out of view
     * @param element The element to be removed
     * @param {boolean} remove If true, the element is removed after it fades from view
     * @param {number} speed If specified, overrides the default speed at which items are removed.
     * @return {boolean} True when successful, otherwise false
     * @constructor
     */
    window.JVZoo.Auth.TotpAuthenticator.Hide = function (element, remove, speed) {
        remove = typeof remove === "boolean" ? remove : false;
        speed = typeof speed === "number" ? speed : _hideSpeed;
        var $element = element instanceof $ ? element : $(element);
        if ($element.length < 1) {
            return false;
        }
        if ($element.length === 1) {
            if (remove) {
                $element.fadeOut(speed, function () {
                    $(this).remove();
                });
                return true;
            }
            if ($element.is(':visible')) {
                $element.fadeOut(speed);
            }
            return true;
        }
        $element.each(function (index, target) {
            if (remove) {
                $(target).fadeOut(speed, function () {
                    $(this).remove();
                });
                return;
            }
            if ($element.is(':visible')) {
                $(target).fadeOut(speed);
            }
        });
        return true;
    };


    /**
     * Either Displays the 2FA modal or continues processing
     * @param event
     */
    var onActionThatRequiresAuthentication = function(event){
        event.preventDefault();
        var authCode = document.getElementById("authenticatorCode").value;
        if (authCode !== null && authCode !== '') {
            var form = getAuthForm();
            if (!form) {
                console.error('No auth form found.');
                return;
            }
            form.submit();
            return;
        }

        var loginEmail = getLoginEmailValue();
        if (!loginEmail) {
            console.error("Login email field cannot be empty.");
            return;
        }
        shouldRenderTotpAuthComponent(
            loginEmail
        ).then(function(object1){
        });
    };

    /**
     * Closes the modal without submitting the form
     * @param event
     */
    var onClickCloseModal = function(event){
        event.preventDefault();
        window.JVZoo.Auth.TotpAuthenticator.Hide($("#two-factor-auth"));
        enableLoginSubmitButtons();
        if (window.grecaptcha) {
            grecaptcha.reset();
        }
    };

    window.JVZoo.Auth.TotpAuthenticator.applyBindings = function (root) {
        var $rootElement = root instanceof $ ? root : $(root);
        $rootElement.on('click', '[name=authenticatedSubmit]', onActionThatRequiresAuthentication);
        $rootElement.on('click', '[id=closeModal]', onClickCloseModal);
    };

    $(document).ready(function () {
        window.JVZoo.Auth.TotpAuthenticator.applyBindings(document);
    });

})(window, jQuery);